import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgAirConditioning32 = props => _jsx("svg", _objectSpread(_objectSpread({
  width: 32,
  height: 32,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 3v6.459l5.813-5.813.707.708-6.52 6.518V15.5h4.625l6.521-6.52.708.707L22.54 15.5H29v1h-6.46l5.814 5.813-.708.707-6.519-6.52H16.5v4.627l6.52 6.52-.707.707L16.5 22.54V29h-1v-6.46l-5.813 5.814-.707-.708 6.52-6.521V16.5h-4.628l-6.518 6.52-.708-.707L9.46 16.5H3v-1h6.459L3.646 9.687l.708-.707 6.52 6.52H15.5v-4.626l-6.52-6.52.707-.708L15.5 9.46V3h1Z",
    fill: props.color || "#58595B"
  })
}));
export default SvgAirConditioning32;